
import { defineComponent } from "vue";

export default defineComponent({
  name: "BaseSelect",
  props: {
    label: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  setup(_, context) {
    const updateSelect = (evt: Event) => {
      context.emit(
        "update:modelValue",
        (evt.target as HTMLSelectElement).value
      );
    };

    return {
      updateSelect,
    };
  },
});
